export const translations = {
  en: {
    nav: { shop: "Shop", how: "How it works", faq: "FAQ", reviews: "Guarantees", cart: "Cart" },
    promo: {
      banner: "🔥 LAUNCH OFFER · 60% OFF · 24H SHIPPING · ONLY THIS WEEK",
      cartLabel: "Promo 3-for-2 applied",
      cartHint: "Add {n} more to unlock another free cup",
      cartUnlocked: "You saved €{saved}",
    },
    hero: {
      eyebrow: "★ Slushy Maker Cup",
      title1: "POUR.",
      title2: "FREEZE.",
      title3: "SQUEEZE.",
      sub: "Turn any juice into a frozen treat in minutes. No machines. No mess. Just squeeze.",
      cta: "Shop Velora — €5.99",
      cta2: "How it works",
      badge1: "BPA Free",
      badge2: "Reusable",
      badge3: "11.83 oz",
      badge4: "Ships Worldwide",
    },
    marquee: "VIRAL PRODUCTS · REAL QUALITY ✦ 24H SHIPPING FROM SPAIN ✦ SECURE STRIPE PAYMENT ✦ 30-DAY RETURNS",
    shop: {
      eyebrow: "Pick your cup",
      title: "Six flavors. One squeeze.",
      sub: "Each Velora cup has its own personality. Pick yours.",
      addToCart: "Add to cart — €5.99",
      personality: "Personality",
      flavor: "Flavor vibe",
    },
    how: {
      eyebrow: "How it works",
      title: "Frozen in 3 steps",
      sub: "From fridge to face in under 5 minutes.",
      step1Title: "Freeze",
      step1Desc: "Pop your empty Velora cup in the freezer for 8–12 hours. The built-in food-grade refrigerant does the work.",
      step2Title: "Pour",
      step2Desc: "Pour your favorite chilled drink — juice, soda, lemonade, you name it — right into the cup.",
      step3Title: "Squeeze",
      step3Desc: "Squeeze, squeeze, squeeze. In about 2 minutes you have a perfect homemade slushy.",
    },
    features: {
      eyebrow: "Why Velora",
      title: "Built to chill.",
      f1Title: "Food-grade silicone",
      f1Desc: "Soft, squeezable, non-deformable. Safe for everyday use.",
      f2Title: "Two-in-one spoon + straw",
      f2Desc: "Eat it, sip it, scoop it. The included tool does it all.",
      f3Title: "Non-slip grip",
      f3Desc: "Textured cup body holds steady in cold, wet hands.",
      f4Title: "11.83 oz capacity",
      f4Desc: "8.1in × 4.2in — big enough to share. Or not.",
    },
    reviews: {
      eyebrow: "★★★★★ 4.9 / 5",
      title: "What people say",
      r1: { quote: "My kids legitimately fight over this. We bought four.", name: "Maya R.", role: "Verified buyer" },
      r2: { quote: "I made a frozen margarita with this at a pool party. Game changer.", name: "Diego F.", role: "Verified buyer" },
      r3: { quote: "Better than the slushie machine I paid $200 for. Seriously.", name: "Priya K.", role: "Verified buyer" },
    },
    faq: {
      eyebrow: "FAQ",
      title: "Questions, answered.",
      items: [
        { q: "How long does it take to freeze?", a: "Leave the empty cup in the freezer for at least 8 hours (overnight is best). After that, your slushy is ready in about 2 minutes of squeezing." },
        { q: "Is it dishwasher safe?", a: "We recommend hand-washing the cup with warm soapy water to protect the inner refrigerant layer. The lid and straw are dishwasher safe." },
        { q: "What drinks work best?", a: "Any cold liquid with some sugar content works great — juice, soda, lemonade, sports drinks. Pure water won't slush properly." },
        { q: "Do you ship internationally?", a: "Yes! We ship worldwide. Standard shipping is 5–10 business days." },
        { q: "What's your return policy?", a: "30-day money-back guarantee. If you don't love it, we'll refund you. No questions." },
      ],
    },
    cart: {
      title: "Your cart",
      empty: "Your cart is empty.",
      emptyCta: "Browse cups",
      subtotal: "Subtotal",
      shipping: "Shipping calculated at checkout",
      checkout: "Checkout with Stripe",
      remove: "Remove",
      qty: "Qty",
    },
    checkout: {
      preparing: "Preparing your checkout...",
      successTitle: "Payment successful!",
      successSub: "Thank you for ordering from Velora. A confirmation email is on its way.",
      successCta: "Back to shop",
      checking: "Checking payment status...",
      processing: "Payment is being processed...",
      failedTitle: "Payment failed",
      failedSub: "Something went wrong. Please try again.",
      timeout: "Status check timed out. Check your email for confirmation.",
      cancelTitle: "Checkout cancelled",
      cancelSub: "No worries — your cart is still here whenever you're ready.",
      cancelCta: "Back to cart",
    },
    footer: {
      tagline: "Frozen treats. Squeeze required.",
      shop: "Shop",
      help: "Help",
      brand: "Brand",
      contact: "Contact",
      faq: "FAQ",
      shipping: "Shipping",
      returns: "Returns",
      story: "Our story",
      newsletter: "Get 10% off your first cup",
      newsletterSub: "Frozen treats, drop alerts, no spam.",
      subscribe: "Subscribe",
      emailPlaceholder: "you@email.com",
      rights: "© 2026 Velora. All rights reserved.",
      subscribed: "Thanks! You're in.",
    },
  },
  es: {
    nav: { shop: "Tienda", how: "Cómo funciona", faq: "Preguntas", reviews: "Garantías", cart: "Carrito" },
    promo: {
      banner: "🔥 OFERTA DE LANZAMIENTO · 60% DTO · ENVÍO 24H · SOLO ESTA SEMANA",
      cartLabel: "Promo 3x2 aplicada",
      cartHint: "Añade {n} más y consigue otro vaso gratis",
      cartUnlocked: "Ahorras €{saved}",
    },
    hero: {
      eyebrow: "★ Vaso para Slushy",
      title1: "VIERTE.",
      title2: "CONGELA.",
      title3: "APRIETA.",
      sub: "Convierte cualquier jugo en un granizado en minutos. Sin máquinas. Sin desorden. Solo aprieta.",
      cta: "Compra Velora — €5.99",
      cta2: "Cómo funciona",
      badge1: "Sin BPA",
      badge2: "Reutilizable",
      badge3: "350 ml",
      badge4: "Envío mundial",
    },
    marquee: "PRODUCTOS VIRALES · CALIDAD REAL ✦ ENVÍO 24H DESDE ESPAÑA ✦ PAGO SEGURO STRIPE ✦ DEVOLUCIÓN 30 DÍAS",
    shop: {
      eyebrow: "Elige tu vaso",
      title: "Seis sabores. Un apretón.",
      sub: "Cada vaso Velora tiene su propia personalidad. Elige el tuyo.",
      addToCart: "Agregar al carrito — €5.99",
      personality: "Personalidad",
      flavor: "Sabor",
    },
    how: {
      eyebrow: "Cómo funciona",
      title: "Granizado en 3 pasos",
      sub: "Del congelador a tu boca en menos de 5 minutos.",
      step1Title: "Congela",
      step1Desc: "Coloca tu vaso Velora vacío en el congelador por 8–12 horas. El refrigerante grado alimenticio hace el trabajo.",
      step2Title: "Vierte",
      step2Desc: "Vierte tu bebida fría favorita — jugo, refresco, limonada, lo que sea — directamente en el vaso.",
      step3Title: "Aprieta",
      step3Desc: "Aprieta, aprieta, aprieta. En 2 minutos tienes un granizado casero perfecto.",
    },
    features: {
      eyebrow: "Por qué Velora",
      title: "Hecho para enfriar.",
      f1Title: "Silicona grado alimenticio",
      f1Desc: "Suave, apretable, no se deforma. Seguro para uso diario.",
      f2Title: "Cuchara + popote 2 en 1",
      f2Desc: "Cómelo, bébelo, sírvelo. La herramienta incluida lo hace todo.",
      f3Title: "Agarre antideslizante",
      f3Desc: "Cuerpo texturizado que se sostiene firme con manos frías y mojadas.",
      f4Title: "Capacidad de 350 ml",
      f4Desc: "20.5 cm × 10.6 cm — suficiente para compartir. O no.",
    },
    reviews: {
      eyebrow: "★★★★★ 4.9 / 5",
      title: "Lo que dice la gente",
      r1: { quote: "Mis hijos literalmente pelean por este vaso. Compramos cuatro.", name: "Maya R.", role: "Compradora verificada" },
      r2: { quote: "Hice una margarita congelada en una fiesta. Increíble.", name: "Diego F.", role: "Comprador verificado" },
      r3: { quote: "Mejor que la máquina de granizados de $200 que tenía. En serio.", name: "Priya K.", role: "Compradora verificada" },
    },
    faq: {
      eyebrow: "PREGUNTAS",
      title: "Dudas, resueltas.",
      items: [
        { q: "¿Cuánto tarda en congelar?", a: "Deja el vaso vacío en el congelador al menos 8 horas (de un día para otro es ideal). Después, tu granizado está listo en 2 minutos de apretarlo." },
        { q: "¿Se puede lavar en el lavavajillas?", a: "Recomendamos lavar el vaso a mano con agua tibia y jabón para proteger la capa interna de refrigerante. La tapa y el popote sí van al lavavajillas." },
        { q: "¿Qué bebidas funcionan mejor?", a: "Cualquier líquido frío con algo de azúcar — jugo, refresco, limonada, bebidas deportivas. El agua pura no congela como granizado." },
        { q: "¿Envían internacionalmente?", a: "¡Sí! Enviamos a todo el mundo. Envío estándar de 5–10 días hábiles." },
        { q: "¿Cuál es la política de devoluciones?", a: "Garantía de devolución de 30 días. Si no te encanta, te devolvemos tu dinero. Sin preguntas." },
      ],
    },
    cart: {
      title: "Tu carrito",
      empty: "Tu carrito está vacío.",
      emptyCta: "Ver vasos",
      subtotal: "Subtotal",
      shipping: "Envío calculado al pagar",
      checkout: "Pagar con Stripe",
      remove: "Quitar",
      qty: "Cant",
    },
    checkout: {
      preparing: "Preparando tu pago...",
      successTitle: "¡Pago exitoso!",
      successSub: "Gracias por tu pedido en Velora. Tu confirmación va en camino al correo.",
      successCta: "Volver a la tienda",
      checking: "Verificando el pago...",
      processing: "Procesando el pago...",
      failedTitle: "Pago fallido",
      failedSub: "Algo salió mal. Intenta de nuevo.",
      timeout: "La verificación tardó demasiado. Revisa tu correo para la confirmación.",
      cancelTitle: "Pago cancelado",
      cancelSub: "Tranquilo — tu carrito sigue ahí cuando estés listo.",
      cancelCta: "Volver al carrito",
    },
    footer: {
      tagline: "Granizados caseros. Aprieta y disfruta.",
      shop: "Tienda",
      help: "Ayuda",
      brand: "Marca",
      contact: "Contacto",
      faq: "Preguntas",
      shipping: "Envíos",
      returns: "Devoluciones",
      story: "Nuestra historia",
      newsletter: "10% de descuento en tu primer vaso",
      newsletterSub: "Granizados, lanzamientos, sin spam.",
      subscribe: "Suscribirse",
      emailPlaceholder: "tu@correo.com",
      rights: "© 2026 Velora. Todos los derechos reservados.",
      subscribed: "¡Gracias! Estás dentro.",
    },
  },
};

export const useT = (lang) => translations[lang] || translations.en;
